import { useMemo } from "react";
import { useAppSelector } from "../../framework/redux/hooks";
import {
    makeSelectCalculatedWorkHoursAmountByDate,
    makeSelectCalculatedWorkHoursAmountByDateGroupedByCategory,
    makeSelectCalculatedWorkHoursAmountByDateGroupedBySalaryRowTypeId,
    makeSelectCalculatedWorkHoursAmountByDateGroupedByWorkShiftIdAndDate,
    makeSelectCalculatedWorkHoursByDate,
    makeSelectNormalWorkHoursAmountByDate,
    makeSelectNormalWorkHoursAmountByDateGroupedByCategory,
    makeSelectNormalWorkHoursAmountByDateGroupedByWorkShiftIdAndDate,
    makeSelectNormalWorkHoursByDate,
} from "../../framework/redux/slices/workHoursSlice";
import {
    dailyAllowanceCategories,
    deductionHourBookingCategories,
    paidHourBookingCategories,
    fillingHourCategories,
} from "../../models/workHours/workHoursItem";

export const useSelectCalculatedWorkHoursAmountBySalaryRowTypeId = (
    rangeStart: string,
    rangeEnd: string
) => {
    const state = useAppSelector((state) => state.workHours);

    const selectWorkHoursAmountByDate = useMemo(
        makeSelectCalculatedWorkHoursAmountByDateGroupedBySalaryRowTypeId,
        []
    );
    return selectWorkHoursAmountByDate(state, rangeStart, rangeEnd);
};

export const useSelectDailyAllowancesByDate = (
    rangeStart: string,
    rangeEnd: string,
    normalOnly = false
) => {
    const state = useAppSelector((state) => state.workHours);
    const categories = useMemo(() => dailyAllowanceCategories(), []);
    const selectWorkHoursByDate = useMemo(
        normalOnly
            ? makeSelectNormalWorkHoursByDate
            : makeSelectCalculatedWorkHoursByDate,
        [normalOnly]
    );

    return selectWorkHoursByDate(state, rangeStart, rangeEnd, categories);
};

export const useSelectPaidWorkHoursAmountByDate = (
    rangeStart: string,
    rangeEnd: string,
    normalOnly = true
) => {
    const state = useAppSelector((state) => state.workHours);

    const categories = useMemo(() => paidHourBookingCategories(), []);
    const selectWorkHoursAmountByDate = useMemo(
        normalOnly
            ? makeSelectNormalWorkHoursAmountByDate
            : makeSelectCalculatedWorkHoursAmountByDate,
        [normalOnly]
    );
    return selectWorkHoursAmountByDate(state, rangeStart, rangeEnd, categories);
};

export const useSelectPaidWorkHoursAmountByWorkShiftIdAndDate = (
    rangeStart: string,
    rangeEnd: string,
    normalOnly = true
) => {
    const state = useAppSelector((state) => state.workHours);

    const categories = useMemo(() => paidHourBookingCategories(), []);
    const selectWorkHoursAmountByDate = useMemo(
        normalOnly
            ? makeSelectNormalWorkHoursAmountByDateGroupedByWorkShiftIdAndDate
            : makeSelectCalculatedWorkHoursAmountByDateGroupedByWorkShiftIdAndDate,
        [normalOnly]
    );
    return selectWorkHoursAmountByDate(state, rangeStart, rangeEnd, categories);
};

export const useSelectDeductionWorkHoursAmountByDateGroupedByCategory = (
    rangeStart: string,
    rangeEnd: string,
    normalOnly = true
) => {
    const state = useAppSelector((state) => state.workHours);

    const categories = useMemo(() => deductionHourBookingCategories(), []);
    const select = useMemo(
        normalOnly
            ? makeSelectNormalWorkHoursAmountByDateGroupedByCategory
            : makeSelectCalculatedWorkHoursAmountByDateGroupedByCategory,
        [normalOnly]
    );
    return select(state, rangeStart, rangeEnd, categories);
};

export const useSelectFillingHoursAmountByDate = (
    rangeStart: string,
    rangeEnd: string,
    normalOnly = true
) => {
    const state = useAppSelector((state) => state.workHours);

    const categories = useMemo(() => fillingHourCategories(), []);
    const selectWorkHoursAmountByDate = useMemo(
        normalOnly
            ? makeSelectNormalWorkHoursAmountByDate
            : makeSelectCalculatedWorkHoursAmountByDate,
        [normalOnly]
    );
    return selectWorkHoursAmountByDate(state, rangeStart, rangeEnd, categories);
};
